module.exports = __webpack_public_path__ + "static/media/9@720w.812e451b.jpg";